import classNames from 'clsx';
import React from 'react';
import useDarkMode from 'use-dark-mode';

import { Direction } from '@swf/components/Slider/Slider';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import { useIsMobileDevice } from '@swf/poker';

import { TXTWCL_LetXs_start } from './Banner.messages.json';
import styles from './Banner.scss';

interface Props {
  title: React.ReactNode;
  text?: React.ReactNode;
  onDirection?: (direction: Direction) => void;
  className?: string;
}

const Banner = ({ title, text = '', onDirection, className }: Props) => {
  const { value: isDarkMode } = useDarkMode();
  const isMobileDevice = useIsMobileDevice(true);

  return (
    <div className={classNames(styles.banner, className)}>
      {isMobileDevice && <CloseButton variant={isDarkMode ? Variant.Light : Variant.Dark} />}
      <h3>{title}</h3>
      {text && <p>{text}</p>}
      {isMobileDevice && (
        <StarsButton
          type="submit"
          className={styles.mobileButton}
          onClick={() => onDirection && onDirection(Direction.RIGHT)}
          translation={TXTWCL_LetXs_start}
        />
      )}
      {isMobileDevice && <CloseButton variant={isDarkMode ? Variant.Light : Variant.Dark} />}
    </div>
  );
};

export default Banner;
